import TABS from '../App/tabs';
import { appConfig, APP_TYPES, BRAND, APP_STATES, PROJECT_VERSION } from '@config';

import Scene from '@scene';
import { resetOptions, hideLoads, setObjectType, show3DLabels } from '@reducers/options/actions';
import { isValidAppType } from '@services/helper.service';
import {
  getMaterialNames, getProfileTypes, getProfileSizes, getProfileShape,
  setSpinner as setProfileSpinner
} from '@reducers/web-services/profile/actions';
import { 
  setProfileFamily, 
  setProfileSize, 
  setProfileMaterial, 
  resetProfiles, 
  resetApplicationState 
} from '@reducers/selectors/application/actions';
import { defaultProfileState, defaultMaterialState } from './web-services/profile';
import { resetDimensionState, setOrientationActiveBtn } from './selectors/dimension/actions';
import { 
  setRebarDesign, 
  setDesignFixedAnchorageDepthFixedAnchorageHef, 
  resetDesignState,
  setDesignEmbedmentDepthOption,
  setDesignFixedAnchorageDepthSpecify
} from './selectors/design/actions';
import { REBAR } from './selectors/design/types';
import { standardList, countryList, brandList } from './../app.values';
import { resetLoadsState } from './selectors/loads/actions';
import { resetMaterialState, setConcreteStrength } from './selectors/material/actions';
import { setScrewOptions } from './options/screw/actions';
import { download, readFile } from '../services/helper.service';
import { setCameraState, resetCameraState, setAxisOrientation, setPerspectiveCamera } from './camera/actions';
import { setOptionsState, resetOptions as resetOptionsState } from './options/actions';
import { setSelectorsState, resetSelectorsState } from './selectors/actions';
import { setWebServicesState, resetWebServicesState } from './web-services/actions';
import initService from '@services/requests/init.service';
import { loadTranslations } from '@texts';
import { loadTooltipss } from './../texts/tooltips';
import { callErrorNotification } from '@components/Notification';
import { updateClientUnits } from './web-services/report/actions';
import tabs from '../App/tabs';
import { EventManager, EVENTS } from '@components/Events/events';
import { getMasonryMaterials, getConcreteStrengthValue } from './web-services/material/actions';
import { initCalculateTab } from './web-services/calculate/actions';
import AbstractGenerator from '@scene/misc/generator';
import { imperialUnits, metricUnits } from '.';
import { MOMENT, LOAD } from './units';
import { mergeDeep } from '@services/helper.service';
import Beam from '@scene/objects/beam';
import { setBeamType } from './options/beam/actions';
import Axis from '@scene/axis';
import { CameraOrientations } from './camera/defaults/generalCalculation';
import { INTERNAL_TYPES } from './selectors/loads';
import { SafetyBarrierObject } from '@object-generators/safety-barrier';
import { buttonsOptions as safetyBarrierButtons } from './selectors/application/initialState-safety-barrier';
import { initState as loadsInitState } from './selectors/loads/index';
import { initState as initAppState } from './selectors/application/index';
import { EmbedmentOptions } from './selectors/design';
import { CladdingTypes } from '@object-generators/safety-barrier/objects/cladding';
import { initialState as claddingInitState } from './options/cladding';
import { getSBPredefinedBPs } from './web-services/application/actions';
import { WoodConnectionObject } from '@object-generators/wood-connection';
import { initialState as nailInitState } from './options/nail/index';
import { initState as calculateInitState } from './selectors/calculate/index';
import { initState as designInitState } from './selectors/design/index';
import { initState as dimensionInitState } from './selectors/dimension/index';
import { initState as materialInitState } from './selectors/material/index';

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_APP_TYPE = 'SET_APP_TYPE';
export const SET_DESIGN_STANDARD = 'SET_DESIGN_STANDARD';
export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_PROFILE_TYPE = 'SET_PROFILE_TYPE';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_ORIENTATION = 'SET_ORIENTATION';
export const SET_MODE = 'SET_MODE';

export const SET_DISTANCE_UNIT = 'SET_DISTANCE_UNIT';
export const SET_WEIGHT_UNIT = 'SET_WEIGHT_UNIT';
export const SET_TEMPERATURE_UNIT = 'SET_TEMPERATURE_UNIT';
export const SET_STRENGTH_UNIT = 'SET_STRENGTH_UNIT';
export const SET_MOMENT_UNIT = 'SET_MOMENT_UNIT';
export const SET_LOAD_UNIT = 'SET_LOAD_UNIT';
export const SET_AREA_UNIT = 'SET_AREA_UNIT';

export const SET_APP_STATUS = 'SET_APP_STATUS';
export const SET_MAIN_STATE = 'SET_MAIN_STATE';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const RESET_ORIENTATION = 'RESET_ORIENTATION';
export const SET_PROJECT_NAME = 'SET_PROJECT_NAME';
export const RESET_PROJECT_NAME = 'RESET_PROJECT_NAME';
export const SET_EXTEND_TIMEOUT = 'SET_EXTEND_TIMEOUT';
export const SET_DIMENSIONS_LABELS = 'SET_DIMENSIONS_LABELS';

/*
  Action creators
 */
export function init() {
  return (dispatch, getState) => {
    Scene.init(getState().main.units);

    dispatch(setActiveTab(TABS.OPTIONS));
    dispatch(setAppType(appConfig.APP_TYPES.GENERAL_CALCULATION));
  };
}

export function setMainState(state) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MAIN_STATE, state });
    Scene.updateUnits(getState().main.units); // must update also the scene units when loading a project
  };
}

export function setMode(mode) {
  return dispatch => {
    dispatch({ type: SET_MODE, mode });

    Scene.updateMode(mode);
  };
}

export function setActiveTab(tabId) {
  return (dispatch) => {
    EventManager.emit(EVENTS.TAB_SWITCHED, tabId);
    dispatch({ type: SET_ACTIVE_TAB, tabId });
  };
}

export function setAppType(appType) {
  return (dispatch, getState) => {
    let state = getState();

    // VladP: Set the appType anyway to reset units and options
    // if (state.main.appType !== appType) {
      dispatch({ type: SET_APP_TYPE, appType });

      dispatch(resetApplicationState(appType));
      dispatch(resetDimensionState(appType));
      dispatch(resetLoadsState(appType));
      dispatch(resetMaterialState(appType));
      dispatch(resetOptions(appType));
      dispatch(resetWebServicesState());
      dispatch(resetDesignState());
      if (state.selectors.application[appType].hasOwnProperty('profile') &&
        (state.selectors.application[appType].profile.family == null ||
          state.selectors.application[appType].profile.size == null ||
          state.selectors.application[appType].profile.material == null))
        dispatch(setProfileType(state.main.localization.profileType));

      // Specific settings
      if (appType === APP_TYPES.GENERAL_CALCULATION && state.main.localization.designStandard === standardList['Masonry'].toString()){
        // Set masonry default orientation to wall
        dispatch(setOrientation(AbstractGenerator.orientation.Y_INVERT));
        dispatch(setAxisOrientation({ 
          orientation3D: Axis.types.Y_TOP
        }));
        dispatch(setOrientationActiveBtn('2'));
        dispatch(setPerspectiveCamera(CameraOrientations.Y_TOP.perspectiveCamera));
        // ~
        dispatch(getMasonryMaterials());
        dispatch(setScrewOptions({
          padding: {
            s1: 200,
            s2: 200
          }
        }));
      }
      if (Number(state.main.localization.designStandard) === standardList['ICC.Cast']) {
        dispatch(setDesignFixedAnchorageDepthFixedAnchorageHef(101.6)); // 4 in
      }
      
      if (appType === APP_TYPES.REBAR_REINFORCEMENT) {
        if (Number(state.main.localization.designStandard) === standardList['AS3600'] || 
            Number(state.main.localization.designStandard) === standardList['ANZ'])
          dispatch(setRebarDesign(REBAR.types.AS3600));
        else if (Number(state.main.localization.designStandard) === standardList['AS5216'])
          dispatch(setRebarDesign(REBAR.types.AS5216));
        else
          dispatch(setRebarDesign(REBAR.types.EUROCODE_2));
      }

      if (Number(state.main.localization.designStandard) === standardList['EU'] ||
        Number(state.main.localization.designStandard) === standardList['AnnexC']) {
        // set default concrete strength 
        dispatch(setConcreteStrength('1'));
        dispatch(getConcreteStrengthValue('1'));
      }

      if (BRAND === brandList.Spit && Number(state.main.localization.country) === countryList.France &&
        (Number(state.main.localization.designStandard) === standardList['EU'] ||
        Number(state.main.localization.designStandard) === standardList['AnnexC'])) {
        // set default embedment option to standard embedment depth
        dispatch(setDesignFixedAnchorageDepthSpecify(true));
        dispatch(setDesignEmbedmentDepthOption(EmbedmentOptions.standard));
      }
      
      if (appType === APP_TYPES.SAFETY_BARRIER) {
        dispatch(setObjectType(SafetyBarrierObject.types.EDGE_SLAB));
        dispatch(getSBPredefinedBPs());
      }

      if (appType === APP_TYPES.WOOD_CONNECTION)
          dispatch(setObjectType(WoodConnectionObject.types.STRAIGHT));
      //~Specific settings

      state = getState();

      Scene.updateCamera(state.camera);
      // VladP: Moved to resetOptions function
      // Scene.updateAppType(appType, {
      //   ...state.options,
      //   mode: state.main.mode,
      //   designStandard: state.main.localization.designStandard
      // });
    // }
  };
}

export function setDesignStandard(designStandard) {
  return (dispatch, getState) => {
    let state = getState();
    let appType = getState().main.appType;
    if (state.main.localization.designStandard !== designStandard) {
      dispatch({ type: SET_DESIGN_STANDARD, designStandard });

      if (!isValidAppType(state.main.appType, designStandard)) {
        if (isValidAppType(APP_TYPES.GENERAL_CALCULATION, designStandard))
          appType = APP_TYPES.GENERAL_CALCULATION;
        else if (isValidAppType(APP_TYPES.BRACKET_ATTACHMENT, designStandard))
          appType = APP_TYPES.BRACKET_ATTACHMENT;
        else if (isValidAppType(APP_TYPES.SAFETY_BARRIER, designStandard))
          appType = APP_TYPES.SAFETY_BARRIER;
        else if (isValidAppType(APP_TYPES.REBAR_REINFORCEMENT, designStandard))
          appType = APP_TYPES.REBAR_REINFORCEMENT;
      }
    }
    // VladP: Set the appType anyway to reset units and options
    dispatch(setAppType(appType));

    // VladP: Removed because it was updating the application with the previous application's options
    // The appType is updated inside the "setAppType"
    // Scene.updateAppType(appType, {
    //   ...state.options,
    //   mode: state.main.mode,
    //   designStandard: designStandard
    // });

  };
}

export function setCountry(country) {
  return (dispatch) => {
    dispatch ({type: SET_COUNTRY, country});
  };
}

export function setCountryUnits(country) {
  return (dispatch) => {
    // let oldCountry = getState().main.localization.country; 
    // if (Number(oldCountry) !== Number(country)) {
      let isUpdated = false;
      if (BRAND === brandList.Redhead) {
        if (Number(country) !== countryList.Canada) {
          dispatch(setUnit(SET_AREA_UNIT, imperialUnits.area, false));
          dispatch(setUnit(SET_LOAD_UNIT, imperialUnits.load, false));
          dispatch(setUnit(SET_MOMENT_UNIT, imperialUnits.moment, false));
          dispatch(setUnit(SET_WEIGHT_UNIT, imperialUnits.weight, false));
          dispatch(setUnit(SET_DISTANCE_UNIT, imperialUnits.distance, false));
          dispatch(setUnit(SET_STRENGTH_UNIT, imperialUnits.strength, false));
          dispatch(setUnit(SET_TEMPERATURE_UNIT, imperialUnits.temperature, false));
          Scene.updateUnits(mergeDeep({}, imperialUnits));
          isUpdated = true;
        }
      } 
      else if (BRAND === brandList.Spit) {
        if (Number(country) === countryList.France) {
          dispatch(setUnit(SET_AREA_UNIT, metricUnits.area, false));
          dispatch(setUnit(SET_LOAD_UNIT, LOAD.DECANEWTON, false));
          dispatch(setUnit(SET_MOMENT_UNIT, MOMENT.DECANEWTON_METER, false));
          dispatch(setUnit(SET_WEIGHT_UNIT, metricUnits.weight, false));
          dispatch(setUnit(SET_DISTANCE_UNIT, metricUnits.distance, false));
          dispatch(setUnit(SET_STRENGTH_UNIT, metricUnits.strength, false));
          dispatch(setUnit(SET_TEMPERATURE_UNIT, metricUnits.temperature, false));
          let franceUnits = mergeDeep({}, metricUnits, {
            load: LOAD.DECANEWTON,
            moment: MOMENT.DECANEWTON_METER,
          });
          Scene.updateUnits(franceUnits);
          isUpdated = true;
        }
      }
    
      if (!isUpdated) {
        dispatch(setUnit(SET_AREA_UNIT, metricUnits.area, false));
        dispatch(setUnit(SET_LOAD_UNIT, metricUnits.load, false));
        dispatch(setUnit(SET_MOMENT_UNIT, metricUnits.moment, false));
        dispatch(setUnit(SET_WEIGHT_UNIT, metricUnits.weight, false));
        dispatch(setUnit(SET_DISTANCE_UNIT, metricUnits.distance, false));
        dispatch(setUnit(SET_STRENGTH_UNIT, metricUnits.strength, false));
        dispatch(setUnit(SET_TEMPERATURE_UNIT, metricUnits.temperature, false));
        Scene.updateUnits(mergeDeep({}, metricUnits));
      }
    // }
  };
}

export function setProfileType(profileType) {
  return (dispatch, getState) => {
    let state = getState();

    if (state.main.localization.profileType !== profileType) {
      dispatch({ type: SET_PROFILE_TYPE, profileType });
      dispatch(resetProfiles());
    }

    if (state.main.appType !== APP_TYPES.REBAR_REINFORCEMENT) {
      dispatch(setProfileSpinner(true));
      // dispatch(getMaterialNames());
      dispatch(getMaterialNames((materials) => {
        if (materials && materials.length) {
          let mat = materials.find((material) => {
            return material.InternalName === defaultMaterialState[BRAND][state.main.appType];
          });

          if (mat === null || mat === undefined)
            mat = materials[0];

          dispatch(setProfileMaterial(mat.InternalName));
        }
      }));
        if (state.main.appType === APP_TYPES.WOOD_CONNECTION) {
          dispatch(setProfileSpinner(false));
        return;
      }
      dispatch(getProfileTypes((profileTypes) => {
        if (profileTypes && profileTypes.length) {
          let profType = Number(getState().main.localization.designStandard) === standardList["Masonry"] ? 3 : (profileType || 0);
          let type = profileTypes.find((type) => {
            return type.InternalName === defaultProfileState[state.main.appType][profType].family;
          });
          if (type === null || type === undefined)
            type = profileTypes[0];
          dispatch(setProfileFamily(type.InternalName));

          if (type.InternalName === "None") {
            dispatch(setBeamType(Beam.types.NONE));
            dispatch(setProfileSpinner(false));
          } else {
            dispatch(getProfileSizes(type.InternalName,
              (profileSizes) => {
                if (profileSizes && profileSizes.length) {
                  let size = profileSizes.find((size) => {
                    return size.InternalName === defaultProfileState[state.main.appType][profileType || 0].size;
                  });
                  if (size === null || size === undefined)
                    size = profileSizes[0];
                  dispatch(setProfileSize(size.InternalName));
                  dispatch(getProfileShape(type.InternalName, size.InternalName, true));
                }
                dispatch(setProfileSpinner(false));
              })
            );
          }
        }
      }));
    }
  };
}

export function setLanguage(language) {
  return { type: SET_LANGUAGE, language };
}

export function setOrientation(orientation) {
  return dispatch => {
    dispatch({ type: SET_ORIENTATION, orientation });

    Scene.updateObjectOrientation(orientation);
  };
}

// Units
export function setDistanceUnit(value) {
  return setUnit(SET_DISTANCE_UNIT, value);
}
export function setWeightUnit(value) {
  return setUnit(SET_WEIGHT_UNIT, value);
}
export function setTemperatureUnit(value) {
  return setUnit(SET_TEMPERATURE_UNIT, value);
}
export function setStrengthUnit(value) {
  return setUnit(SET_STRENGTH_UNIT, value);
}
export function setMomentUnit(value) {
  return setUnit(SET_MOMENT_UNIT, value);
}
export function setLoadUnit(value) {
  return setUnit(SET_LOAD_UNIT, value);
}
export function setAreaUnit(value) {
  return setUnit(SET_AREA_UNIT, value);
}
function setUnit(type, value, updateClient = true) {
  return (dispatch, getState) => {
    dispatch({ type, value });
    if (updateClient)
      dispatch(updateClientUnits());

    Scene.updateUnits(getState().main.units);
  };
}
//

export function sendCalculateRequest() {
  return (dispatch, getState) => {
    const state = getState();

    console.log(state);
  };
}

export function setAppStatus(status) {
  return (dispatch, getState) => {
    const oldState = getState().main.status;

    // prevent changing status to something else than INITIALIZED before init for the first time 
    // allow loading a new state without initialization
    if (oldState === APP_STATES.NOT_INITIALIZED && (status !== APP_STATES.INITIALIZED && status !== APP_STATES.LOADING_NEW_STATE))
      return;

    dispatch({ type: SET_APP_STATUS, value: status });
  };
}

export function forceRevalidation() {
  return (dispatch, getState) => {
    if (getState().main.status === APP_STATES.REVIEW_OPTIONS)
      dispatch(setAppStatus(APP_STATES.NOT_INITIALIZED));
  };
}

export function saveProject() {
  return (dispatch, getState) => {
    const state = getState();

    download((state.main.projectName || 'your-project') + '.iexpert', JSON.stringify(state));
  };
}

export function openProjectFile() {
  return (dispatch, getState) => {
    readFile().then(res => {
      var obj = null, fileName = null;
      try {
        obj = JSON.parse(res.contents);
        if (res.fileName.lastIndexOf('.') === -1)
          fileName = res.fileName;
        else 
          fileName = res.fileName.slice(0, res.fileName.lastIndexOf('.'));
      } catch (error) {
        callErrorNotification(error.message);
        return;
      }

      var initialStatus = getState().main.status;
      dispatch(setAppStatus(APP_STATES.LOADING_NEW_STATE));
      initService.initializeWith({
        CountryKey: obj.main.localization.country,
        DesignStandard: obj.main.localization.designStandard,
        LanguageKey: obj.main.localization.language,
        AvailableProfileTypes: obj.main.localization.profileType,
        Brand: BRAND,
        userProfile: obj.main.userProfile
      }).then(async (response) => {
        if (response) { // VladP: Successfully initialized
          obj.main.status = APP_STATES.LOADING_NEW_STATE; // set the active accordion item based on this
          if (!obj.main.projectVersion || obj.main.projectVersion < PROJECT_VERSION)
            obj = updateProjectState(obj);
          // dispatch(setAppType(obj.main.appType));
          dispatch(setMainState(obj.main));
          dispatch(setCameraState(obj.camera));
          dispatch(setOptionsState(obj.options));
          dispatch(setSelectorsState(obj.selectors));
          dispatch(setWebServicesState(obj.webServices));
          dispatch(setProjectName(fileName));
          
          await loadTranslations();
          await loadTooltipss();
          
          Scene.update(getState());
          
          if (obj.main.activeTab === TABS.CALCULATE) {
            (async () => {
              await dispatch(initCalculateTab());
            })();
          }

          // VladP: Set the active tab to trigger the render of App.js in order to update accordion titles
          dispatch(setActiveTab(obj.main.activeTab));

          if (obj.main.appType !== APP_TYPES.REBAR_REINFORCEMENT) {
            let profile = obj.selectors.application[obj.main.appType].profile;
            dispatch(getProfileSizes(profile.family));
            dispatch(getProfileShape(profile.family, profile.size));
          }
          
          dispatch(setAppStatus(APP_STATES.INITIALIZED));
        } else {
          dispatch(setAppStatus(initialStatus));
        }
      });
    });
  };
}

export function newProject() {
  return (dispatch, getState) => {
    if (getState().main.status !== APP_STATES.NOT_INITIALIZED) {
      dispatch(setAppStatus(APP_STATES.LOADING_NEW_STATE));
  
      // VladP: Created an immediate function which return a promise to be able to change the application status after everything is reset
      // The application status will change to initialized before finishing the reset and will not change the application accordion
      (() => new Promise((resolve, reject) => {
        dispatch(setAppType(APP_TYPES.GENERAL_CALCULATION));
        // dispatch(setProfileType(getState().main.localization.profileType));
        dispatch(resetCameraState());
        dispatch(resetOptionsState());
        dispatch(resetSelectorsState());
        dispatch(resetWebServicesState());
        dispatch(resetProjectName());
        
        Scene.update(getState());
        
        dispatch(setActiveTab(tabs.APPLICATION));
        dispatch(hideLoads());
        // dispatch(hide3DDimensions());
        resolve();
      }))().then(() => {
        dispatch(setAppStatus(APP_STATES.INITIALIZED));
      });
    }
  };
}

export function setUserProfile(userProfile) {
  return (dispatch) => {
    dispatch({ type: SET_USER_PROFILE, value: userProfile });
  };
}

export function resetOrientation(){
  return (dispatch, getState) => {
    let value = AbstractGenerator.orientation.X;
    if (getState().main.appType === APP_TYPES.SAFETY_BARRIER)
      value = null;
    else if ((getState().main.appType === APP_TYPES.GENERAL_CALCULATION &&
              Number(getState().main.localization.designStandard) === standardList["Masonry"]) ||
              getState().main.appType === APP_TYPES.BRACKET_ATTACHMENT)
      value = AbstractGenerator.orientation.Y_INVERT;

    dispatch({ 
      type: RESET_ORIENTATION, 
      value
    });
  };
}

export function setProjectName(projectName) {
  return (dispatch) => {
    dispatch({ type: SET_PROJECT_NAME, value: projectName });
  };
}

export function resetProjectName() {
  return (dispatch) => {
    dispatch({ type: RESET_PROJECT_NAME });
  };
}

// export function setExtendTimeout(shouldExtend) {
//   return (dispatch) => {
//     dispatch({ type: SET_EXTEND_TIMEOUT, value: shouldExtend });
//   };
// }

export function setDimensionsLabels(value) {
  return (dispatch) => {
    dispatch({ type: SET_DIMENSIONS_LABELS, value });
    dispatch(show3DLabels(value));
  };
}

function updateProjectState(state) {
  var newState = mergeDeep({}, state);
  if (newState.main.projectVersion === null || newState.main.projectVersion === undefined || newState.main.projectVersion === 0) {
    newState.selectors.loads[APP_TYPES.SAFETY_BARRIER].hasInternalDirection = true;
    newState.selectors.loads[APP_TYPES.SAFETY_BARRIER].internalDirection = {
      type: INTERNAL_TYPES.CUSTOM_PER_LENGTH,
      loadBetweenPosts: 0.4,
      loadPerLength: state.selectors.loads[APP_TYPES.SAFETY_BARRIER].internalDirection.value
    };

    newState.main.projectVersion = 1;
  }

  if (newState.main.projectVersion === 1) {
    newState.options.beam.height = 10;
    newState.options.object.loads.editable = true;
    newState.options.object.dimensions = {
      display: true,
      showLabels: true,
      displayHorizontally: false
    };

    newState.main.projectVersion = 2;
  }

  if (newState.main.projectVersion === 2) {
    // newState.selectors.application.safetyBarrierButtons.buttonsOptions[2].subtypes =
    //   newState.selectors.application.safetyBarrierButtons.buttonsOptions[2].subtypes.map((item, idx) => { 
    //     item.config = mergeDeep({}, safetyBarrierButtons[2].subtypes[idx].config);
    //     return item; 
    // });
    var subtypes = newState.selectors.application.safetyBarrierButtons.buttonsOptions[2].subtypes;
    subtypes = subtypes.map((item, idx) => { 
      item.config = mergeDeep({}, safetyBarrierButtons[2].subtypes[idx].config);
      return item; 
    });

    if (newState.main.appType === APP_TYPES.SAFETY_BARRIER && 
      newState.selectors.application[APP_TYPES.SAFETY_BARRIER].selectedType.id === 'pedestal') 
    {
      newState.selectors.application[APP_TYPES.SAFETY_BARRIER].selectedType.subtypes = subtypes;
      newState.selectors.application[APP_TYPES.SAFETY_BARRIER].selectedSubtype = mergeDeep({}, 
        subtypes.find(subtype => subtype.id === newState.selectors.application[APP_TYPES.SAFETY_BARRIER].selectedSubtype.id));
    }

    newState.main.projectVersion = 3;
  }

  if (newState.main.projectVersion === 3) {
    newState.selectors.loads[APP_TYPES.GENERAL_CALCULATION].importState = 
      mergeDeep({}, loadsInitState[APP_TYPES.GENERAL_CALCULATION].importState);
      
    newState.main.projectVersion = 4;
  }

  if (newState.main.projectVersion === 4) {
      newState.selectors.application[APP_TYPES.SAFETY_BARRIER].predefinedBasePlate =
          mergeDeep({}, initAppState[APP_TYPES.SAFETY_BARRIER].predefinedBasePlate);

      newState.main.projectVersion = 5;
  }

  if (newState.main.projectVersion === 5) {
    newState.selectors.application[APP_TYPES.SAFETY_BARRIER].cladding = CladdingTypes.None;
    newState.options.cladding = mergeDeep({}, claddingInitState);
    newState.main.projectVersion = 6;
  }

  if (newState.main.projectVersion === 6) {
    newState.selectors.application[APP_TYPES.WOOD_CONNECTION] = mergeDeep({}, initAppState[APP_TYPES.WOOD_CONNECTION]);
    newState.selectors.calculate[APP_TYPES.WOOD_CONNECTION] = mergeDeep({}, calculateInitState[APP_TYPES.WOOD_CONNECTION]);
    newState.selectors.design[APP_TYPES.WOOD_CONNECTION] = mergeDeep({}, designInitState[APP_TYPES.WOOD_CONNECTION]);
    newState.selectors.dimension[APP_TYPES.WOOD_CONNECTION] = mergeDeep({}, dimensionInitState[APP_TYPES.WOOD_CONNECTION]);
    newState.selectors.loads[APP_TYPES.WOOD_CONNECTION] = mergeDeep({}, loadsInitState[APP_TYPES.WOOD_CONNECTION]);
    newState.selectors.material[APP_TYPES.WOOD_CONNECTION] = mergeDeep({}, materialInitState[APP_TYPES.WOOD_CONNECTION]);
    newState.options.nail = mergeDeep({}, nailInitState);
    newState.main.projectVersion = 7;
  }

  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/actions.js